import Vue from 'vue'
import store from '@/store'
import messages from 'lang'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// creating a instance of vue localisation module
const i18n = new VueI18n({
  locale: store.getters.selectedLocale.locale,
  messages
})

export default i18n
